(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["mag-sticky-cta"] && !Shopify.designMode) return;
  try {
    
(function () {
  var bar = document.querySelector('[data-mag-sticky-cta]');
  var hero = document.getElementById('mag-hero');
  if (!bar || !hero) return;

  bar.hidden = false;

  new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        bar.classList.toggle('is-visible', !entry.isIntersecting);
      });
    },
    { threshold: 0 }
  ).observe(hero);

  var offers = document.getElementById('mag-oferta');
  if (!offers) return;

  new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        bar.classList.toggle('is-compact', entry.isIntersecting);
      });
    },
    { threshold: 0 }
  ).observe(offers);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nac-sticky-cta"] && !Shopify.designMode) return;
  try {
    
(function () {
  var bar = document.querySelector('[data-nac-sticky-cta]');
  var hero = document.getElementById('nac-hero');
  if (!bar || !hero) return;

  bar.hidden = false;

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        bar.classList.toggle('is-visible', !entry.isIntersecting);
      });
    },
    { threshold: 0 }
  );

  observer.observe(hero);
})();

  } catch(e) { console.error(e); }
})();
})();
